import React, { useState } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, MenuItem, Select, FormControl,
    InputLabel, RadioGroup, FormControlLabel, Radio,
    Box,
    Typography,
    Modal,
    Backdrop,
    Fade,
    IconButton
} from "@mui/material";
import BASE_URL, { COMMUNITYADMINS } from "../../NetworkConfig/ApiConfig";
import { CloseRounded } from "@mui/icons-material";

const AddEventPopup = ({ open, onClose, children, onSelect = () => { }, width = 420 }) => {


    return (
        <Modal
            open={open}
            onClose={onClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 300 }}
        >
            <Fade in={open}>
                <Box sx={styles.popup(width)}>

                    {/* Header */}
                    <Box sx={styles.header}>
                        <span style={styles.title}>{"Tag Events"}</span>
                        <IconButton onClick={onClose}>
                            <CloseRounded />
                        </IconButton>
                    </Box>

                    {/* Body */}
                    <Box sx={styles.body}>
                        {children}
                    </Box>

                </Box>
            </Fade>
        </Modal>
    );
};

const styles = {
    popup: (width) => ({
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width,
        maxWidth: "90%",
        maxHeight: "85vh",
        bgcolor: "#0f0f0f",
        borderRadius: 3,
        boxShadow: 24,
        overflow: "hidden"
    }),
    header: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 2,
        py: 1,
        borderBottom: "1px solid #aaaaaa20"
    },
    title: {
        fontSize: "14px",
        fontFamily: "poppins-reg"
    },
    body: {
        p: 2,
        overflowY: "auto"
    }
};


export default AddEventPopup;
